export const labelType = 'label';
export const linkType = 'link';
export const linkWithActionType = 'link-with-action';
export const linkWithCountType = 'link-with-count';
export const linkWithActionCountType = 'link-with-action-count';
